export function getModalMatriz(state) {
    return state.modalMatriz
}